import { render, staticRenderFns } from "./examInvoiceAcceptOld.vue?vue&type=template&id=3278d286"
import script from "./examInvoiceAcceptOld.vue?vue&type=script&lang=js"
export * from "./examInvoiceAcceptOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports